module.exports = __webpack_public_path__ + "static/media/avesha-thumbnail.fc723662.png";